export default __webpack_public_path__ + "static/media/guest_18_02.bbf5a95b.png";